import { render } from "./UpdateVimeoLinks.vue?vue&type=template&id=512151a3&scoped=true"
import script from "./UpdateVimeoLinks.vue?vue&type=script&lang=js"
export * from "./UpdateVimeoLinks.vue?vue&type=script&lang=js"

import "./UpdateVimeoLinks.vue?vue&type=style&index=0&id=512151a3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512151a3"]])

export default __exports__